import useHttpGet from './useHttpGet';

const useThrowableHttpGet = (...args) => {
  const { error, ...rest } = useHttpGet(...args);

  if (error) {
    throw error;
  }

  return rest;
};

export default useThrowableHttpGet;
